import React, { useState } from "react";
import { Layout } from "antd";
import ContentSider from "../../../components/templates/ContentSider";
import Surface from "../../../components/layouts/Surface";
import Spacer from "../../../components/layouts/Spacer";
import SubMenu from "../../../components/templates/SubMenu";
import SystemTable from "../../../components/templates/SystemTable";
import ColumnsSettings from "../../salary/settings";
import Tariffs from "../../tariffs";
import { AuditOutlined } from "@ant-design/icons";
import { FormattedMessage } from "react-intl";
const { Content } = Layout;

const Wage = (props) => {
  const { activekey } = props;
  const [menuKey, setMenuKey] = useState("wage_symbols");

  const onMenuSelect = ({ key }) => {
    setMenuKey(key);
  };
  const selectData = [
    { value: 1, name: <FormattedMessage id="app.salary.quantity" /> },
    { value: 2, name: <FormattedMessage id="app.salary.sum" /> },
  ];

  let ActiveComponent = null;
  switch (menuKey) {
    case "wage_symbols":
      ActiveComponent = () => (
        <SystemTable
          source="salary/salary_symbols"
          nonEditable={["description"]}
          built_in_non_editable={["name", "type"]}
          initialSorter={"name"}
          fields={[
            { key: "name", required: true, focused: true, sorter: true },
            { key: "symbol", required: true, sorter: true },
            {
              key: "type",
              type: "select",
              required: true,
              selectData: selectData,
              sorter: true,
            },
            { key: "deduction", type: "checkbox" },
            { key: "exported_to_file", type: "checkbox" },
          ]}
        />
      );
      break;
    case "wage_rates":
      ActiveComponent = () => <Tariffs />;
      break;
    case "salary_settings":
      ActiveComponent = () => <ColumnsSettings />;
      break;

    default:
      ActiveComponent = () => <SystemTable source="salary/salary_symbols" />;
      break;
  }

  const items = [
    {
      name: "wage_symbols",
      category: "settings",
      icon: <AuditOutlined />,
    },
    {
      name: "wage_rates",
      category: "settings",
      icon: <AuditOutlined />,
    },
    {
      name: "salary_settings",
      category: "settings",
      icon: <AuditOutlined />,
    },
  ];

  return (
    <Layout style={{ background: "transparent", height: "100%" }}>
      <Spacer horizontal={true} smallMargin={true} />
      <ContentSider width={250}>
        <SubMenu
          onMenuSelect={onMenuSelect}
          items={items}
          selectedKeys={[menuKey]}
        />
      </ContentSider>
      <Content style={{ minHeight: 280, flex: 1 }}>
        <Surface>{activekey === "wage" && <ActiveComponent />}</Surface>
      </Content>
    </Layout>
  );
};

export default Wage;
